import { DeleteIcon, DeleteOrangeIcon, FolderMoveIcon, FolderMoveOrangeIcon } from '@_shared/icons';

import { Typography } from '@_shared/ui/Typography';
import * as S from './ContentListEditNavigationBar.style';

interface ContentListEditNavigationBarProps {
	isActive: boolean;
	openContentDeletePopup: () => void;
	openContentListFolderUpdateModal: () => void;
}

export function ContentListEditNavigationBar({
	isActive,
	openContentDeletePopup,
	openContentListFolderUpdateModal,
}: ContentListEditNavigationBarProps) {
	return (
		<S.NavigationBar>
			<S.NavigationBarItem onClick={openContentListFolderUpdateModal}>
				{isActive ? <FolderMoveOrangeIcon /> : <FolderMoveIcon />}
				<Typography
					type="label-medium"
					color={isActive ? 'orange-primary' : 'warmgray-300'}
				>
					폴더 이동
				</Typography>
			</S.NavigationBarItem>
			<S.NavigationBarItem onClick={openContentDeletePopup}>
				{isActive ? <DeleteOrangeIcon /> : <DeleteIcon />}
				<Typography
					type="label-medium"
					color={isActive ? 'orange-primary' : 'warmgray-300'}
				>
					삭제
				</Typography>
			</S.NavigationBarItem>
		</S.NavigationBar>
	);
}
